import React, { useState, useEffect } from "react";
// Relojes
import figure2 from "../../assets/images/icons/card/clocks/hora-agengado.png";
import figure4 from "../../assets/images/icons/card/clocks/hora-retraso.png";
import figure5 from "../../assets/images/icons/card/clocks/hora-finalizo.png";
import figure6 from "../../assets/images/icons/card/clocks/hora-entro.png";
// Carros
import figure1 from "../../assets/images/icons/card/vehicles/carros.png";
import figure7 from "../../assets/images/icons/card/vehicles/tracto.png";
import figure8 from "../../assets/images/icons/card/vehicles/camion.png";
import figure9 from "../../assets/images/icons/card/vehicles/cisterna.png";
import figure10 from "../../assets/images/icons/card/vehicles/container.png";
import figure11 from "../../assets/images/icons/card/vehicles/camion3.png";

import { getVisit } from "../../client/administration/board/index";
import { getEvents } from "../../client/administration/event";

const SOCKET_URL =  "ws://8f65-38-25-8-218.ngrok-free.app/ws";

const Card = ({ filterCompany, filterPlate, filterSearch }) => {
    const [visitas, setVisitas] = useState([]);
    const [filteredVisitas, setFilteredVisitas] = useState([]);
    const [eventsData, setEventsData  ] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
      fetchVisitas();
      const socket = new WebSocket(SOCKET_URL);
    
      socket.onopen = () => {
        console.log("Conectado al WebSocket");
      };
    
      socket.onmessage = (event) => {
        const message = JSON.parse(event.data);  // Datos recibidos desde el WebSocket
        const {  Payload } = message; // Extraemos Type y Payload
    
        // Verificamos que el tipo del mensaje sea el esperado
        if (Payload) {
          const updatedVisitId = Payload.Id;
         
    
          console.log("Visita actualizada:", Payload);
    
          // Actualizamos las visitas con el nuevo estado recibido
          setVisitas((prevVisitas) => {
            return prevVisitas.map((visit) =>
              visit.id === updatedVisitId
                ? { ...visit, estado: Payload.Estado || visit.estado, horaCambioEstado: new Date() }
                : visit
            );
          });
    
          // Actualizamos los eventos relacionados con la visita
          setEventsData((prevEvents) => {
            return prevEvents.map((event) =>
              event.idVisit === updatedVisitId
                ? { ...event, estado: Payload.Estado || event.estado,...updatedVisitId} // Actualizando el evento con la nueva fecha de salida
                : event
            );
          });
    
          // Refrescar todas las visitas con un nuevo fetch
          fetchVisitas();
        }
      };
    
    
      socket.onerror = (err) => {
        console.error("Error de conexión con WebSocket:", err);
      };
    
      socket.onclose = () => {
        console.log("Desconectado del WebSocket");
      };
    
      return () => {
        socket.close();
      };
    }, []);

    const fetchVisitas = async () => {
      setLoading(true);
      try {
        const response = await getVisit();
        const visitsData = response.data;
        const eventsResponse = await getEvents();
        const eventsData = eventsResponse.data;
    
        const eventIds = new Set(eventsData.map(event => event.idVisit));
        const currentTime = new Date();
    
        const updatedVisits = visitsData.map(visit => {
          const hasEvent = eventIds.has(visit.id);
    
          if (hasEvent) {
            const matchingEvent = eventsData.find(event => event.idVisit === visit.id);
    
            if (matchingEvent.ouputWeighting > 0) {
              return { ...visit, estado: "Salió", horaCambioEstado: new Date() };
            } else {
              return { ...visit, estado: "Entró" };
            }
          }
    
          return { ...visit, estado: "Agendado" };
        });
    
        const finalUpdatedVisits = updatedVisits.map(visit => {
          const startDate = new Date(visit.startDateScheduled);
          const matchingEvent = eventsData.find(event => event.idVisit === visit.id);
    
          const arrivalDate = matchingEvent && matchingEvent.dateOfEntry
            ? new Date(matchingEvent.dateOfEntry)
            : null;
    
          if (visit.estado === "Entró" && arrivalDate && arrivalDate > startDate) {
            return { ...visit, estado: "Retraso" };
          }
    
          return visit;
        });
    
        setEventsData(eventsData);
        setVisitas(finalUpdatedVisits);
      } catch (error) {
        console.error('Error fetching visits:', error);
      } finally {
        setLoading(false);
      }
    };
    useEffect(() => {
      const filtered = visitas.filter((visita) => {
        // Asegúrate de que las propiedades estén definidas
        const companyName = visita.companyName || "";
        const plate = visita.plate || "";
        const categoryName = visita.categoryName || "";
        const driverName = visita.driverName || "";
        const dni = visita.dni || "";
    
        // Filtros
        const companyFilter = filterCompany ? companyName.includes(filterCompany) : true;
        const plateFilter = filterPlate ? plate.toLowerCase().startsWith(filterPlate.toLowerCase()) : true;
        const matchesSearchTerm = filterSearch
          ? categoryName.toLowerCase().includes(filterSearch.toLowerCase()) ||
            plate.toLowerCase().includes(filterSearch.toLowerCase()) ||
            driverName.toLowerCase().includes(filterSearch.toLowerCase()) ||
            dni.toLowerCase().includes(filterSearch.toLowerCase()) ||
            companyName.toLowerCase().includes(filterSearch.toLowerCase())
          : true;
    
        return companyFilter && plateFilter && matchesSearchTerm;
      });
    
      setFilteredVisitas(filtered);
    }, [filterCompany, filterPlate, filterSearch, visitas]);

    const agendados = filteredVisitas.filter(visita => visita.estado === "Agendado");
    const entro = filteredVisitas.filter(visita => visita.estado === "Entró");
    const salio = filteredVisitas.filter(visita => visita.estado === "Salió");
    const retraso = filteredVisitas.filter(visita => visita.estado === "Retraso");
   
    const getEstadoClass = (estado) => {
      switch (estado) {
        case "Agendado":
          return "bg-[#007696]";
        case "Entró":
          return "bg-[#76A140]";
        case "Salió":
          return "bg-[#FFC700]";
        case "Retraso":
          return "bg-[#CA2D00]"; 
        default:
          return "";
      }
    };
    const getEstadoTexto = (estado) => {
      switch (estado) {
        case "Agendado":
          return "Agendado";
        case "Entró":
          return "En tránsito";
        case "Salió":
          return "Finalizó";
        case "Retraso":
          return "Retrasado"; 
        default:
          return "";
      }
    };
    const getEstadoBorde = (estado) => {
      switch (estado) {
        case "Agendado":
          return "border-[#007696]"; 
        case "Entró":
          return "border-[#76A140]";  
        case "Salió":
          return "border-[#FFC700]";  
        case "Retraso":
          return "border-[#CA2D00]"; 
        default:
          return "border-[#007696]";  
      }
    };
    const getPlacaColor = (estado) => {
      switch (estado) {
        case "Agendado":
          return "text-[#007696]";  
        case "Entró":
          return "text-[#76A140]";  
        case "Salió":
          return "text-[#FFC700]";  
        case "Retraso":
          return "text-[#CA2D00]"; 
        default:
          return "text-[#007696]";  
      }
    };
    const getHoraColor = (estado) => {
      switch (estado) {
        case "Agendado":
          return "text-[#007696]"; 
        case "Entró":
          return "text-[#76A140]";  
        case "Salió":
          return "text-[#FFC700]";  
        case "Retraso":
          return "text-[#CA2D00]"; 
        default:
          return "text-[#007696]";  
      }
    };
    const getHoraImage = (estado) => {
      switch (estado) {
        case "Agendado":
          return figure2;
        case "Entró":
          return figure6;
        case "Salió":
          return figure5;
        case "Retraso":
          return figure4; 
        default:
          return figure2; 
      }
    };

    const formatHour = (date) => {
      const d = new Date(date);
      let hours = d.getHours();
      let minutes = d.getMinutes();
      
      // Añadir un cero a la izquierda si las horas o minutos son menores de 10
      hours = hours < 10 ? `0${hours}` : hours;
      minutes = minutes < 10 ? `0${minutes}` : minutes;
      
      return `${hours}:${minutes}`;
    };

    const calculateTimeDifference = (visita, events) => {
      if (visita.estado === "Entró") {
          const matchingEvent = events.find(event => event.idVisit === visita.id);
          if (!matchingEvent) return "N/A";

          const entryTime = new Date(matchingEvent.dateOfEntry);
          const currentTime = new Date();
          const diffInMilliseconds = entryTime - currentTime;

          return formatTimeDifference(diffInMilliseconds);
      } 
      else if (visita.estado === "Retraso") {
          const matchingEvent = events.find(event => event.idVisit === visita.id);
          if (!matchingEvent) return "N/A";

          const scheduledTime = new Date(visita.startDateScheduled);
          const actualEntryTime = new Date(matchingEvent.dateOfEntry);
          const diffInMilliseconds = actualEntryTime - scheduledTime;

          return formatTimeDifference(diffInMilliseconds);
      }
      return "";
  };

  const formatTimeDifference = (milliseconds) => {
      const seconds = Math.floor(milliseconds / 1000);
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);

      if (hours > 0) {
          return `${hours}h ${minutes % 60}m`;
      } else if (minutes > 0) {
          return `${minutes}m ${seconds % 60}s`;
      } else {
          return `${seconds}s`;
      }
  };

  const calculateTimeDifferenceSalio = (fechaCambioEstado) => {
    const tiempoActual = new Date();
    const tiempoPasado = tiempoActual - new Date(fechaCambioEstado);
    
    const segundos = Math.floor(tiempoPasado / 1000);
    const minutos = Math.floor(segundos / 60);
    const horas = Math.floor(minutos / 60);
    
    if (horas > 0) {
      return `${horas}h ${minutos % 60}m`;
    } else if (minutos > 0) {
      return `${minutos}m ${segundos % 60}s`;
    } else {
      return `${segundos}s`;
    }
  };

  const normalizeText = (text) => {
    return text
      .toLowerCase() // Convertir a minúsculas
      .normalize("NFD") // Normalizar caracteres Unicode (separar acentos)
      .replace(/[\u0300-\u036f]/g, ""); // Eliminar acentos
  };

  const getVehicleImage = (typeVehicle) => {
    const normalizedType = normalizeText(typeVehicle);
    switch (normalizedType) {
      case "camion":
        return figure8; 
      case "cisterna":
        return figure9; 
      case "tracto":
        return figure7; 
      default:
        return figure8; 
    }
  };

    return (
      <div className="">
        <div className="flex gap-6  overflow-x-scroll md:overflow-x-auto">
            {/* Agendados */}
            <div
                id="agendados"
                className="w-[100%] md:w-[33%] lg:md:w-[33%] 4k:md:w-[33%] 2xl:md:w-[33%] bg-[#8AC0CF33] p-3 rounded-md mb-8"
            >
                <div className="flex justify-between pb-2">
                    <div className="flex gap-4">
                        <p className="font-itcbold text-[20px]">AGENDADOS</p>
                        <div className="flex justify-center items-center w-[30px] h-[30px] bg-[#B4E1F6] text-black font-itcdemi text-[13px] rounded-full">
                            {agendados.length}
                        </div>
                    </div>
                </div>
                <div className={`max-h-screen ${agendados.length > 2 ? 'overflow-y-scroll' : 'overflow-hidden'} scroll-container`}>
                    <div className="grid gap-2 2xl:grid-cols-1 md:grid-rows-6 des:grid-cols-2 4k:grid-cols-3">
                        {agendados.map((visita, index) => (
                            <div key={index} className={`border-[9px] ${getEstadoBorde(visita.estado)} bg-white rounded-[20px] p-2 pl-3 pr-3 flex flex-col justify-around`}>
                                <div className="flex justify-between mt-1">
                                    <span className={`font-itcbold text-[18px] ${getPlacaColor(visita.estado)}`}>{visita.plate}</span>
                                    <p id="agendado"  className={`font-itcmedium text-center text-[15px] h-[26px] w-[105px] rounded-[5px] text-white ${getEstadoClass(visita.estado)}`}>{getEstadoTexto(visita.estado)}</p>
                                </div>
                                {/* DATOS DEL CONDUCTOR */}
                                <div className="flex items-center">
                                    <div className="mt-2 w-[60%] font-itcbook text-[16px] text-[#808080]">
                                        <p>{visita.driverName}</p>
                                        <p>{visita.dni}</p>
                                        <p>{visita.companyName}</p>
                                    </div>
                                    <div className="ml-[2.5rem] w-[30%] md:ml-[2.5rem] lg:ml-4 xl:ml-[2.5rem] 2xl:ml-28 des:ml-20 4k:ml-[7.5rem]">
                                      <img src={getVehicleImage(visita.typeVehicle)} alt="carro" className="w-[54px] h-[54px]" />
                                    </div>
                                </div>
                                
                                <div className="space-y-3">
                                  <hr className="my-3 border-[#808080]" />
                                  <div className="flex justify-between">
                                    <div className="flex items-center gap-[2px]">
                                      <div className="">
                                        <img src={getHoraImage(visita.estado)}  alt="hora" className="w-[24px] h-[24px]" />
                                      </div>
                                      <div id="hora" className={`font-itcbold text-[15px] ${getHoraColor(visita.estado)}`}>
                                        <p>{formatHour(visita.startDateScheduled)} a {formatHour(visita.finalDateScheduled)}</p>
                                      </div>
                                    </div>
                                    {/**
                                    <div id="cantidad_usuarios" className="flex items-center gap-[5px]">
                                      <div className="">
                                        <img src={figure3} alt="usuario" className="w-[24px] h-[24px]" />
                                      </div>
                                      <div className="flex justify-center items-center w-[30px] h-[30px] bg-[#8AC0CB] text-black font-itcdemi text-[13px] rounded-full">
                                        10
                                      </div>
                                    </div>*/}
                                </div>

                                </div>
                               
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {/* Entró */}
            <div
                id="entro"
                className="w-[100%] md:w-[33%] lg:md:w-[33%] 4k:md:w-[33%] 2xl:md:w-[33%] bg-[#8AC0CF33] p-3 rounded-md mb-8"
            >
                <div className="flex justify-between pb-2">
                    <div className="flex gap-4">
                        <p className="font-itcbold text-[20px]">ENTRÓ</p>
                        <div className="flex justify-center items-center w-[30px] h-[30px] bg-[#B4E1F6] text-black font-itcdemi text-[13px] rounded-full">
                            {entro.length + retraso.length}
                        </div>
                    </div>
                </div>
                <div className={`max-h-screen ${entro.length && retraso.length > 2 ? 'overflow-y-scroll' : 'overflow-hidden'} scroll-container`}>
                <div className="grid gap-2 2xl:grid-cols-1 md:grid-rows-6 des:grid-cols-2 4k:grid-cols-3">
                    {entro.concat(retraso).map((visita, index) => (
                        <div key={index} className={`border-[9px] ${getEstadoBorde(visita.estado)} bg-white rounded-[20px] p-2 pl-3 pr-3 flex flex-col justify-around`}>
                            <div className="flex justify-between mt-1">
                                <span className={`font-itcbold text-[18px] ${getPlacaColor(visita.estado)}`}>{visita.plate}</span>
                                <p id="entro" className={`font-itcmedium text-center text-[15px] h-[26px] w-[105px] rounded-[5px] text-white ${getEstadoClass(visita.estado)}`}>
                                    {getEstadoTexto(visita.estado)}
                                </p>
                            </div>
                            <div className="flex items-center">
                                <div className="mt-2 w-[60%] font-itcbook text-[16px] text-[#808080]">
                                    <p>{visita.driverName}</p>
                                    <p>{visita.dni}</p>
                                    <p>{visita.companyName}</p>
                                </div>
                                <div className="ml-[2.5rem] w-[30%] md:ml-[2.5rem] lg:ml-4 xl:ml-[2.5rem] 2xl:ml-28 des:ml-20 4k:ml-[7.5rem]">
                                  <img src={getVehicleImage(visita.typeVehicle)} alt="carro" className="w-[54px] h-[54px]" />
                                </div>
                            </div>
                            <div className="space-y-3">
                              <hr className="my-3 border-[#808080]" />
                              <div className="flex justify-between">
                                  <div className="flex items-center gap-[2px]">
                                      <div>
                                          <img src={getHoraImage(visita.estado)} alt="hora" className="w-[24px] h-[24px]" />
                                      </div>
                                      <div id="hora" className={`font-itcbold text-[15px] ${getHoraColor(visita.estado)}`}>
                                          <p>{calculateTimeDifference(visita, eventsData)}</p>
                                      </div>
                                  </div>
                                  {/**
                                  <div id="cantidad_usuarios" className="flex items-center gap-[5px]">
                                      <div>
                                          <img src={figure3} alt="usuario" className="w-[24px] h-[24px]" />
                                      </div>
                                      <div className="flex justify-center items-center w-[30px] h-[30px] bg-[#8AC0CB] text-black font-itcdemi text-[13px] rounded-full">
                                          10
                                      </div>
                                  </div>*/}
                              </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
              

            </div>
            {/* Salió */}
            <div
                id="salio"
                className="w-[100%] md:w-[33%] lg:md:w-[33%] 4k:md:w-[33%] 2xl:md:w-[33%] bg-[#8AC0CF33] p-3 rounded-md mb-8"
            >
                <div className="flex justify-between pb-2">
                    <div className="flex gap-4">
                        <p className="font-itcbold text-[20px]">SALIÓ</p>
                        <div className="flex justify-center items-center w-[30px] h-[30px] bg-[#B4E1F6] text-black font-itcdemi text-[13px] rounded-full">
                            {salio.length}
                        </div>
                    </div>
                </div>
                <div className={`max-h-screen ${salio.length > 2 ? 'overflow-y-scroll' : 'overflow-hidden'} scroll-container`}>
                    <div className="grid gap-2 2xl:grid-cols-1 md:grid-rows-6 des:grid-cols-2 4k:grid-cols-3">
                        {salio.map((visita, index) => (
                            <div key={index} className={`border-[9px] ${getEstadoBorde(visita.estado)} bg-white rounded-[20px] p-2 pl-3 pr-3 flex flex-col justify-around`}>
                              <div className="flex justify-between mt-1">
                                  <span className={`font-itcbold text-[18px] ${getPlacaColor(visita.estado)}`}>{visita.plate}</span>
                                  <p id="salio"  className={`font-itcmedium text-center text-[15px] h-[26px] pt-1 w-[105px] rounded-[5px] text-white ${getEstadoClass(visita.estado)}`}>{getEstadoTexto(visita.estado)}</p>
                              </div>
                              {/* DATOS DEL CONDUCTOR */}
                              <div className="flex items-center">
                                  <div className="mt-2 w-[60%] font-itcbook text-[16px] text-[#808080]">
                                      <p>{visita.driverName}</p>
                                      <p>{visita.dni}</p>
                                      <p>{visita.companyName}</p>
                                  </div>
                                  <div className="ml-[2.5rem] w-[30%] md:ml-[2.5rem] lg:ml-4 xl:ml-[2.5rem] 2xl:ml-28 des:ml-20 4k:ml-[7.5rem]">
                                    <img src={getVehicleImage(visita.typeVehicle)} alt="carro" className="w-[54px] h-[54px]" />
                                  </div>
                              </div>
                              <div className="space-y-3">
                                <hr className="my-3 border-[#808080]" />
                                <div className="flex justify-between">
                                  <div className="flex items-center gap-[2px]">
                                    <div className="">
                                      <img src={getHoraImage(visita.estado)}  alt="hora" className="w-[24px] h-[24px]" />
                                    </div>
                                    <div id="hora" className={`font-itcbold text-[15px] ${getHoraColor(visita.estado)}`}>
                                      <p>{calculateTimeDifferenceSalio(visita.finalDateScheduled)}</p>
                                    </div>
                                  </div>

                                  {/**<div id="cantidad_usuarios" className="flex items-center gap-[5px]">
                                    <div className="">
                                      <img src={figure3} alt="usuario" className="w-[24px] h-[24px]" />
                                    </div>
                                    <div className="flex justify-center items-center w-[30px] h-[30px] bg-[#8AC0CB] text-black font-itcdemi text-[13px] rounded-full">
                                      10
                                    </div>
                                  </div>*/}
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
      </div>
    );
};
  
export default Card;
